import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import { useGetAnswerAction } from "../../hooks/useCrm";
import { useEffect } from "react";

const initvalue = {
  IdActivityCrm: null,
  IdS0alesOpportunities: null,
  AnswerActivityCrm: "",
};
export const AnswerActionModal = ({
  show,
  handleClose,
  userdata,
  activityId,
  setInsertActionModal,
}) => {
  const [form, setForm] = useState(initvalue);
  const [button] = useState(false);
  const { mutateAsync: answerAction } = useGetAnswerAction();
  useEffect(() => {
    if (userdata) {
      setForm({
        ...form,
        IdS0alesOpportunities:
          userdata?.sales_opportunities[0]?.IdS0alesOpportunities,
      });
    }
    if (activityId) setForm({ ...form, IdActivityCrm: activityId });
  }, [userdata, activityId]);
  const handleAnswer = async (data) => {
    await answerAction(data).setForm(initvalue);
  };
  return (
    <BootstrapModal
      modaltitle="پاسخ فعالیت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleTextArea
            cols="10"
            rows="3"
            placeholder="پاسخ فعالیت"
            label={"پاسخ فعالیت"}
            onChange={(e) =>
              setForm({ ...form, AnswerActivityCrm: e.target.value })
            }
          />
        </div>

        <div className="col-4">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleAnswer(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
        <div className="col-4">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleAnswer(form);
              setInsertActionModal(true);
              handleClose();
            }}
          >
            تایید و ثبت فعالیت جدید
          </Button>
        </div>
        <div className="col-4">
          <Button
            bgColor="#f7005f"
            color="#fff"
            onclick={() => {
              handleClose();
            }}
          >
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
